import { render, staticRenderFns } from "./LaudoRenovabioModal.vue?vue&type=template&id=6089dd55&scoped=true&lang=pug"
import script from "./LaudoRenovabioModal.vue?vue&type=script&lang=js"
export * from "./LaudoRenovabioModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoRenovabioModal.vue?vue&type=style&index=0&id=6089dd55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6089dd55",
  null
  
)

export default component.exports